import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    workspacesListAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the workspaces list */
            workspacesListAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Workspaces.workspacesListAriaLabel?c=3pqqm1v8iqjzh", defaultMessage: "Workspaces List" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
